/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { CertificateAuthority } from '@modules/cloud-api/v1/types'

import { FETCH_CERTIFICATE_AUTHORITY } from '../../constants/actions'

import type { ReduxState } from '@/types/redux'

type FetchAction = {
  type: typeof FETCH_CERTIFICATE_AUTHORITY
  error?: boolean
  payload?: CertificateAuthority
  meta: { deploymentId: string }
}

type Action = FetchAction

export type State = {
  [deploymentId: string]: CertificateAuthority
}

const initialState: State = {}

export default function certificateAuthorityReducer(
  state: State = initialState,
  action: Action,
): State {
  if (action.type === FETCH_CERTIFICATE_AUTHORITY) {
    if (!action.error && action.payload) {
      const { deploymentId } = action.meta

      return {
        ...state,
        [deploymentId]: action.payload,
      }
    }
  }

  return state
}

const _getCertificateAuthority = (
  state: State,
  deploymentId: string,
): CertificateAuthority | undefined => state[deploymentId]

export function getCertificateAuthority(state: ReduxState, deploymentId: string) {
  return _getCertificateAuthority(state.certificateAuthority, deploymentId)
}
